module.exports = __webpack_public_path__ + "static/media/add-user.4c8dbf63.svg";